import React,{useState} from 'react';
import './Styles/VideoPart.scss';
import image from '../../../Assets/Cards/blog-video.webp';
import {ReactComponent as Play} from '../../../Assets/Icons/play.svg';
import {IoIosArrowBack,IoIosArrowForward} from 'react-icons/io';
import { TabList, Tabs,Tab, TabPanel } from 'react-tabs';
import image2 from '../../../Assets/Cards/nextPanel.webp';
const VideoPart=()=>{
    const [selectedTab, setSelectedTab] = useState(0);
    const tabCount =4;
    return(
        <div className="video-part-blog">
            <div className="video-container">
                <div className="img-part">
               <Play />
              <img src={image} />
                </div>
                <div className="tabs-part">
                    <Tabs selectedIndex={selectedTab} onSelect={index => setSelectedTab(index)}>
                        <h2>Up Next</h2>
                        <TabPanel>
                          <img src={image2} />
                          <p>Productivity hacks & tools for big startups in 2019</p>
                        </TabPanel>
                        <TabPanel>
                          <img src={image2} />
                          <p>The 4 ingredients John Maeda says all the best</p>
                        </TabPanel>
                        <TabPanel>
                          <img src={image2} />
                          <p>These 5 tips will help you nail your next design presentation</p>
                        </TabPanel>
                        <TabPanel>
                          <img src={image2} />
                          <p>How servant leadership can help unlock.</p>
                        </TabPanel>
                        <TabList >
                        <button onClick={() => setSelectedTab((selectedTab + tabCount - 1) % tabCount )}><IoIosArrowBack /></button>
                            <Tab>01</Tab>
                            <Tab>02</Tab>
                            <Tab>03</Tab>
                            <Tab>04</Tab>
                            <button onClick={() => setSelectedTab((selectedTab + 1) % tabCount )}><IoIosArrowForward /></button>
                         </TabList>
                    </Tabs>
                </div>
            </div>
        </div>
    )
};
export default VideoPart ;